import * as React from 'react';

import LearningGoalQuestion from 'bundles/onboarding-common/components/modular/LearningGoalQuestion';
import RoleSelectQuestion from 'bundles/onboarding-common/components/modular/RoleSelectQuestion';
import SkillSelectQuestion from 'bundles/onboarding-common/components/modular/SkillSelectQuestion';
import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import { useOnboardingProgress } from 'bundles/onboarding-common/contexts/OnboardingProgressContext';

const ModularOnboardingQuestionRenderer = () => {
  const { questionId } = useOnboardingProgress();

  switch (questionId) {
    case QUESTION_IDS.learningGoal:
      return <LearningGoalQuestion />;
    case QUESTION_IDS.roleSelect:
      return <RoleSelectQuestion />;
    case QUESTION_IDS.skillSelect:
      return <SkillSelectQuestion />;
    default:
      return null;
  }
};

export default ModularOnboardingQuestionRenderer;
